import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-schedule-update',
  templateUrl: './schedule-update.component.html',
  styleUrls: ['./schedule-update.component.scss']
})
export class ScheduleUpdateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
